export class UserCV {

    public static all: UserCV = new UserCV();

    TYPE_AECFA = 'AECFA';
    TYPE_AENA = 'AENA';
    TYPE_AIRPORT = 'AIRPORT';    
    TYPE_OPERATOR = 'OPERATOR';
    TYPE_PORTAL_EAIRPORTSLOT = 'EAIRPORTSLOT';
    TYPE_PORTAL_OCS = 'OCS';
    TYPE_GESLOT = 'GESLOT';

    ACCESS_TYPE_CRONOSS = 'CRONOSS';
    ACCESS_TYPE_PORTAL = 'PORTAL';

    constructor() {
    }
}
